document.addEventListener("turbolinks:load", function() {
    if($("body").data("controller") == "games") {
        let tableGames;
        let emotion_id;
        let cancelUploading = false;
        let emotion_ids = []
        if ($("#game_emotion_ids").val() != undefined)
            emotion_ids = $("#game_emotion_ids").val().split(",").map((num) => parseInt(num));

        document.addEventListener("turbolinks:before-cache", function() {
            if (tableGames != null) {
                tableGames.destroy();
            }
        })

        tableGames = $('#table-games').DataTable({
            'initComplete': function(settings){
                var api = this.api();
       
                api.cells(
                   api.rows(function(idx, data, node){
                      return ($(node).data('related')) ? true : false;
                   }).indexes(),
                   0
                ).checkboxes.disable();
            },
            'columnDefs': [
                {
                   'targets': 0,
                   'checkboxes': {
                        'selectRow': false,
                        'selectCallback': function(nodes, selected) {
                            refresh_selected_elements()
                        }
                    }
                }
            ],
            'select': {
                'style': 'multi',
                "selector": 'td:first-child'
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": false,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "oLanguage": {
                "sLengthMenu": "_MENU_ ",
                "sInfo": "Showing <b>_START_ to _END_</b> of _TOTAL_ entries"
            },
            "bAutoWidth": false,
            'order' : [[0,'desc']]
        });
        $("#table-games_wrapper > div > .col-sm-6:nth-child(1)").addClass("content-left")
        $("#table-games_wrapper > .row > div:first").append("<div><span>" +
            "<div class='form-check checkbox-circle complete filter-passed'>" + 
                "<input type='checkbox' id='filter-show_not_active' checked>" + 
                "<label for='filter-show_not_active'>Show inactive games</label>" +
            "</div>" + 
        "</span></div>")

        // toggle active/inactive songs
        $("#filter-show_not_active").on("change", function() {
            if($(this).prop("checked")) {
                $.fn.dataTable.ext.search.pop();
            }
            else {
                $.fn.dataTable.ext.search.push(
                    function(settings, data, dataIndex) {
                       return $(tableGames.row(dataIndex).node()).attr('data-active') == 'true';
                    }
                 );
            }

            tableGames.draw();
        })
        
        const lightbox = GLightbox();
        
        FilePond.registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginFileValidateType);
     
        const pond = FilePond.create(document.querySelector('#game-image'), {
            acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
            labelIdle: "Drag & Drop your image or <span class='filepond--label-action'> Browse </span>",
            imagePreviewMinHeight: 128,
            imagePreviewMaxHeight: 128,
            imagePreviewHeight: 128,
            allowProcess: false,
            instantUpload: false,
            name: 'game[image]',
            storeAsFile: true,
            credits: {label: "", url: ""} ,
            maxFileSize: 300000,
        });

        $("#btn-save-game").on("click", function() {
            $("#form-game").validate()

            if ($("#form-game").valid()) {
                $(".loader").removeClass("hidden")
                $(".btn-cancel").attr("disabled", true)
                $("button[type='submit']").attr("disabled", true)
                
                document.getElementById("form-game").submit()
            }
        })

        $('[data-init-plugin="select2"]').each(function () {
            $(this).select2({
                minimumResultsForSearch: ($(this).attr('data-disable-search') == 'true' ? -1 : 1)
            });
        });

        // delete game
        $(".delete-game").on("click", function() {
            game_id = $(this).parent().parent().attr("data-game_id")

            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
              }).then((result) => {
                    if (result.isConfirmed) {
                        destroy(game_id, null)
                    }
              })
        })

        //select elements
        $("#table-games input[type=checkbox]").on("change", function() {
            refresh_selected_elements()
        })
        
        // delete selected elements
        $("#delete-selected-elements").on("click", function() {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    elements = rows_selected
                    $.each(elements, function(index, rowId){
                        $(`#table-games tr[data-game_id='${rowId}'] td:nth-child(7)`).html("<b>Deleting...</b>");
                        $(`#table-games tr[data-game_id='${rowId}'] td:nth-child(6) a`).removeAttr("href")
                        $(`#table-games tr[data-game_id='${rowId}'] .change-state`).off( "click", "");
                        tableGames.cells(`tr[data-game_id='${rowId}']`, 0).checkboxes.disable()
                    })

                    destroy(null, rows_selected.join(","))
                }
            })
        })

        // change state selected elements
        $("#state-selected-elements").on("click", function() {
            Swal.fire({
                title: "Change all selected elements state to ?",
                input: 'select',
                inputOptions: {
                  'true': 'Active',
                  'false': 'Inactive'
                },
                inputPlaceholder: 'Select a state',
                showCancelButton: true,
                inputValidator: (value) => {
                  return new Promise((resolve) => {
                        if (value == "")
                            resolve("Please choose a state")
                        else {
                            changeState(null, value, rows_selected.join(","))
                        }
                  })
                }
              })
        });

        // change state
        $(".change-state").on("click", function() {
            let text = $(this).text() == "true" ? 'Inactive' : 'Active'
            let state = $(this).text() == "true" ? false : true

            Swal.fire({
                title: `Change this game's state to ${text} ?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, change it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    game_id = $(this).parent().parent().attr("data-game_id")
                    changeState(game_id, state)
                }
            })
        })

        $("#video-input").on("click", function() {
            document.getElementById("upfile").click();
        })
        
        $("#upfile").on("change", function(obj) {
            var video_id = $(".video-success-id").text();
            var file_origine = this
            var file = this.value;
            if (file != "") {
                if (isVideo(this.value)) {
                    var fileName = file.split("\\");
                    document.getElementById("video-input").innerHTML = fileName[fileName.length - 1];
                    $(this).attr("disabled", true)

                    $("#btn-save-game").attr("disabled", true)

                    $.ajax({
                        url: "/games/prepare_video",
                        type: 'PUT',
                        dataType: "json",
                        data: {
                            video_id: video_id
                        },
                        success: function (data) {
                            $("#video-id").val(data.video_id)
                            $("#video-url").val(data.video_url)
                            
                            upload(file_origine, data.video_id)
                        },
                        error: function(data) {
                        }
                    });
                }
                else {
                    $(".video-upload-error").removeClass("hidden")
                }
            }
        })

        function upload(file, video_id) {
            
            $(".video-progress").removeClass("hidden")
            $(".video-progress .progress").append("<div class='video-progress-upload-length text-center'>0%</div>" +
                "<div class='progress-bar progress-bar-striped progress-bar-animated video-progress-upload' role='progressbar' aria-valuenow='75' aria-valuemin='0' aria-valuemax='100' style='margin-right: auto; width: 0%'>" +
            "</div>")

            var uploader = new VideoUploader({
                videoId: video_id,
                file: file.files[0],
                uploadToken: "to5pYv2Li3irOb9HwHTdhkE6",
                retries: 10000000
            })

            uploader.upload().then((video) => {
                $(".video-success-info").removeClass("hidden")
                $(".video-success-id").text(video.videoId)
                $(".video-success-url").text(video.assets.mp4)
                $(".video-success-url").parent().attr("href", video.assets.mp4) 
               
                //$("#video-player").html(video.assets.iframe) 

                $("#video-url").val(video.assets.mp4)
                $("#video-id").val(video.videoId)

                $(".video-progress").addClass("hidden")
                $(".video-upload-success").removeClass("hidden")
                $("#btn-save-game").attr("disabled", false)
                $("#upfile").attr("disabled", false)
            })
            .catch((error) => console.log(error.status, error.message));

            uploader.onProgress((event) => {

                if (cancelUploading) {
                    $(".video-progress .progress div").remove()
                    resetUpload()
                    cancelUploading = false
                }

                percent = (event.uploadedBytes / event.totalBytes) * 100
                percent = Number.parseFloat(percent).toFixed(2)

                if (percent > 100) {
                    percent = 100
                }

                $(".video-progress-upload").css("width", percent  + "%")
                $(".video-progress-upload-length").text(percent  + "%")
            })
            
        }

        function resetUpload() {
            $("#video-id").val("")
            $(".video-progress").addClass("hidden")
            $(".video-success-info").addClass("hidden")
            $(".video-progress-upload").css("width", "0%")
            $(".video-progress-upload-length").text("0%")
            $(".video-upload-error").addClass("hidden")
            $("#upfile").attr("disabled", false)
            $("#video-input").text("CLICK TO CHOOSE A FILE")
        }

        function isVideo(filename) {
            var parts = filename.split('.');
            ext = parts[parts.length - 1];

            switch (ext.toLowerCase()) {
              case 'm4v':
              case 'avi':
              case 'mpg':
              case 'mp4':
                // etc
                return true;
            }
            return false;
        }

        function changeState(game_id, state, elements) {
            if (game_id != null) {
                $.ajax({
                    url: "/games/change_state/" + game_id,
                    type: 'PUT',
                    dataType: "json",
                    data: {
                        state: state
                    },
                    success: function (data) {
                        $(`#table-games tr[data-game_id='${game_id}'] .change-state`).text(state);
                        $(`#table-games tr[data-game_id='${game_id}']`).toggleClass("tr-deactivated")
                        $(`#table-games tr[data-game_id='${game_id}']`).attr("data-active", state)

                        if (state) {
                            $(`#table-games tr[data-game_id='${game_id}'] .change-state`).addClass("badge-success")
                            $(`#table-games tr[data-game_id='${game_id}'] .change-state`).removeClass("badge-warning")
                        }
                        else {
                            $(`#table-games tr[data-game_id='${game_id}'] .change-state`).addClass("badge-warning")
                            $(`#table-games tr[data-game_id='${game_id}'] .change-state`).removeClass("badge-success")
                        }
                    },
                    error: function(data) {
                    }
                });
            }
            else if (elements != null) {
                $(".total-selected-content").addClass("hidden")

                $.ajax({
                    url: "/games/change_state",
                    type: 'PUT',
                    dataType: "json",
                    data: {
                        elements_id: elements,
                        state: state
                    },
                    success: function (data) {
                        elements = elements.split(',')
                        
                        $.each(elements, function(index, rowId){
                            $(`#table-games tr[data-game_id='${rowId}'] .change-state`).text(state);
                            $(`#table-games tr[data-game_id='${rowId}']`).attr("data-active", state)
                            tableGames.cells(`tr[data-game_id='${rowId}']`, 0).checkboxes.deselect()

                         
                            if (state == "true") {
                                $(`#table-games tr[data-game_id='${rowId}'] .change-state`).addClass("badge-success")
                                $(`#table-games tr[data-game_id='${rowId}'] .change-state`).removeClass("badge-warning")

                                $(`#table-games tr[data-game_id='${rowId}']`).removeClass("tr-deactivated")
                            }
                            else {
                                $(`#table-games tr[data-game_id='${rowId}'] .change-state`).addClass("badge-warning")
                                $(`#table-games tr[data-game_id='${rowId}'] .change-state`).removeClass("badge-success")
                             
                                $(`#table-games tr[data-game_id='${rowId}']`).addClass("tr-deactivated")
                            }
                            
                        });

                        refresh_selected_elements()

                        Swal.close()
                    },
                    error: function(data) {
                    }
                });
            }
        }

        function destroy(game_id, elements) {
            if (game_id != null) {
                $(`#table-games tr[data-game_id='${game_id}'] td:nth-child(7)`).html("<b>Deleting...</b>");
                $(`#table-games tr[data-game_id='${game_id}'] td:nth-child(6) a`).removeAttr("href")
                $(`#table-games tr[data-game_id='${game_id}'] .change-state`).off( "click", "");
                $(`#table-games tr[data-game_id='${game_id}']`).addClass("tr-deleting")

                tableGames.cells(`tr[data-game_id='${game_id}']`, 0).checkboxes.disable()
                refresh_selected_elements()

                $.ajax({
                    url: "/games/" + game_id,
                    type: 'DELETE',
                    dataType: "json",
                    success: function (data) {
                        tableGames.row($(`tr[data-game_id='${game_id}']`)).remove().draw();

                        if (data.name != null) {
                            messageDeleted = `The game "${data.name}" has been deleted.`
                        }

                    },
                    error: function(data) {
                    }
                });
            }
            if (elements != null) {
                $(".total-selected-content").addClass("hidden")

                $.ajax({
                    url: "/games/delete_elements",
                    type: 'DELETE',
                    dataType: "json",
                    data: {
                        elements_id: elements
                    },
                    success: function (data) {
                        elements = elements.split(',')

                        $.each(elements, function(index, rowId){
                            tableGames.row($(`tr[data-game_id='${rowId}']`)).remove().draw();
                        });

                        $(".total-selected-content").addClass("hidden")
                    },
                    error: function(data) {
                    }
                });
            }
        }
        
        // select emotion
        $(".select-emotion").on("click", function() {
            $(this).toggleClass("emotion_selected")
            emotion_id = $(this).parent().data("emotion_id")
       
            if (emotion_ids.indexOf(emotion_id) != -1) {
                emotion_ids.splice(emotion_ids.indexOf(emotion_id), 1);
            }
            else {
                emotion_ids.push(emotion_id)
            }
            
            $("#game_emotion_id").val(emotion_ids[0])
            $("#game_emotion_ids").val(emotion_ids)

            $(".emotion_txt").removeClass("emotion_bold")
            $(this).next(".emotion_txt").toggleClass("emotion_bold")
        })

        function refresh_selected_elements() {
            rows_selected = tableGames.column(0).checkboxes.selected();

            if (rows_selected.length == 0) {
                $(".total-selected-content").addClass("hidden")
                $(".total-selected-content").css("marginBottom", 0)
                $(".total-selected-content").css("opacity", 0)
            }
            else {
                $(".total-selected-content").removeClass("hidden")
                $(".total-selected-content").animate({
                    marginBottom: 10,
                    opacity: 1
                }, 100, "linear",  function() {
                });
            }
            
            $.each(rows_selected, function(index, rowId){
            });

            let txt = rows_selected.length > 1 ? `${rows_selected.length} elements selected` : `${rows_selected.length} element selected`
            $(".total-selected").text(txt)

            return rows_selected
        }
    }
})